// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import {Change_password_form_new} from
  '../../../../hola/pub/ui/cp/change_password_form';
import {Button} from '../../../../hola/pub/lib/button';
import {Modal} from '../../../../hola/pub/lib/modal';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Checkbox} from '../../../../hola/pub/lib/checkbox';
import zerr from '/util/zerr.js';
import etask from 'zetask';
import {perr} from 'hola_pub_util';
import styles from './account_settings.module.less';
// @ts-ignore
import {fetch} from '/util/fetch.js';

interface i_navigation_props {
  current_view: string;
  on_nav: (view: string)=>void;
}
interface i_account_settings_props {
    on_back: ()=>void;
    modal: string;
    set_modal: React.Dispatch<React.SetStateAction<string>>;
    email: string;
}

const Navigation_bar = ({current_view, on_nav}: i_navigation_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.navigation_wrap}>
      <span onClick={()=>on_nav('main')}
        className={cn(theme.p12, theme.med, theme.color_n300)}>
        My account
      </span>
      <span className={cn(styles.separator, theme.p12, theme.med,
        theme.color_n300)}>
        {'>'}
      </span>
      <span onClick={()=>on_nav('settings')} className={cn(theme.p12,
        theme.med, current_view=='settings' ?
        theme.color_n500 : theme.color_n300)}>
        Account settings
      </span>
    </div>;
};

const Delete_account = ()=>{
    const [delete_acc_open, set_delete_acc_open] = useState(false);
    const [delete_acc_checked, set_delete_acc_checked] = useState(false);
    const [err, set_err] = useState(false);
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const on_confirm = ()=>etask(function*(){
        set_err(false);
        try {
            yield fetch('/users/delete_user', {method: 'POST'});
            location.href = '/';
        } catch(e){
            set_err(true);
            perr({id: 'www_delete_account_err', info: {err: zerr.e2s(e)}});
        }
    });
    return <section className={styles.delete_account_section}>
      <p className={cn(theme.p14, theme.med, theme.color_n700, styles.title)}>
        <T>Delete account</T>
      </p>
      <p className={cn(theme.p12, theme.color_n500,
        styles.delete_acc_warning)}>
        <T>This action is permanent and irreversible. It will delete all your
        activity, including but not limited to previous and any currently
        active plans.</T>
      </p>
      <Button caption={t('Delete your account')} color='transparent'
      round={false} size='xs' on_click={()=>set_delete_acc_open(true)}/>
      <Modal is_open={delete_acc_open} width={520} lighter_close_btn
        on_close={()=>set_delete_acc_open(false)} low_dim paddingless
        on_overlay_click={()=>set_delete_acc_open(false)}>
        <div className={styles.delete_account_popup}>
          <p className={cn(theme.p24, theme.med, theme.color_n700,
            styles.delete_account_heading)}>
              <T>Are you sure!?</T> &#x1F6A8;
          </p>
          <p className={cn(theme.p14, theme.color_n500,
            styles.suggest_cancel_renewal)}>
            <T>You might want cancel</T>&nbsp;
            <span><T>your plan renewal</T></span>
            &nbsp;<T>instead</T>.
          </p>
          <div className={styles.delete_account_info}>
            <p className={theme.p14}><T>If you delete your account</T>:</p>
            <ul>
              <li><T>Know that this is permanent and irreversible</T></li>
              <li><T>You will lose all current proxies and plans</T></li>
              <li><T>You will lose all record of past plans</T></li>
            </ul>
          </div>
          <div className={styles.delete_account_checkbox}>
            <Checkbox checked={delete_acc_checked} size='sm'
              on_change={()=>set_delete_acc_checked(!delete_acc_checked)}/>
            <p className={cn(theme.p12, theme.color_n500)}>
              <T>I acknowledge that all of my account activity will be
                irrevocably deleted, and want to proceed</T>
            </p>
          </div>
          <div className={styles.delete_account_btns}>
            <Button caption={t('Keep account')} color='transparent' fit
              round={false} on_click={()=>set_delete_acc_open(false)}/>
            <Button caption={t('Delete account')} round={false} fit
              disabled={!delete_acc_checked} color='light_red'
              on_click={on_confirm}/>
          </div>
          {err}
          <div className={cn(styles.err_msg, err && styles.visible)}>
            <T>Something went wrong</T></div>
        </div>
      </Modal>
    </section>;
};

export const Account_settings = ({on_back, modal, set_modal, email}:
  i_account_settings_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v({no_defaults: true});
    const {screen} = use_screen();
    const on_nav = view=>{
        if (view == 'main')
            on_back();
    };
    return <>
      <Navigation_bar current_view='settings'
        on_nav={on_nav}/>
      <p className={cn(theme.p18, theme.med, theme.color_n700)}>My password</p>
      <div className={cn(styles.details_container, styles.horizontal)}>
        <Button color="white" size="sm" caption={t('Change password')}
          cls={styles.change_pass_btn} inline round={false}
          on_click={()=>set_modal('change_pass')}/>
        <Modal is_open={modal == 'change_pass'} cls={styles.modal}
          on_close={()=>set_modal(null)} content_when_open
          width={screen == 'xs' ? 335 : 400}>
          <Change_password_form_new
            on_success={()=>set_modal('change_pass_done')}
            email={email}/>
        </Modal>
      </div>
      <Delete_account/>
    </>;
};
